export const ASSETS = {
  logo: "/assets/arcimus-logo.png",
  background: "/assets/arcimus-web-background.png",
  banner: "/assets/arcimus-ban.webp",
};

export const X_URL = "https://x.com/ArcimusPrime";

export const TRADE_LINKS = {
  ca: "COMING SOON",
  buy: "https://argus.world",
  chart: "https://dexscreener.com",
};

export const NAV_LINKS = [
  { label: "COMMAND", path: "/" },
  { label: "LORE", path: "/lore" },
  { label: "PROTOCOL", path: "/protocol" },
  { label: "IDENTITY", path: "/identity" },
  { label: "MISSIONS", path: "/missions" },
  { label: "ECONOMY", path: "/economy" },
  { label: "TERMINAL", path: "/terminal" },
  { label: "DOCS", path: "/docs" },
];

export const FOOTER_LINKS = [
  { label: "Command", path: "/" },
  { label: "About", path: "/about" },
  { label: "Lore", path: "/lore" },
  { label: "Protocol", path: "/protocol" },
  { label: "Identity", path: "/identity" },
  { label: "Missions", path: "/missions" },
  { label: "Economy", path: "/economy" },
  { label: "Roadmap", path: "/roadmap" },
  { label: "Terminal", path: "/terminal" },
  { label: "Docs", path: "/docs" },
  { label: "FAQ", path: "/faq" },
];

export const HERO_HUD = [
  { label: "SYSTEM STATUS", value: "ONLINE" },
  { label: "IDENTITY", value: "VERIFIED" },
  { label: "NETWORK", value: "ARC" },
  { label: "ECONOMY", value: "USDC" },
  { label: "MODE", value: "AUTONOMOUS" },
];

export const SITE_CONFIG = {
  project: "ARCIMUS",
  tagline: "THE FIRST PRIME OF ARC",
  slogan: "RISE. PROTECT. TRANSACT.",
  x_url: X_URL,
  network: "ARC",
  project_status: "ACTIVE",
  launch_state: "LIVE NOW",
};

export const SYSTEM_STATUS = {
  core: "ONLINE",
  identity: "VERIFIED",
  network: "ARC",
  mode: "AUTONOMOUS",
  economy: "USDC",
  system: "LIVE",
  label: "SIMULATION",
};

export const MARQUEE_ITEMS = [
  "HUMANOID AI",
  "AUTONOMOUS MACHINE",
  "MACHINE ECONOMY",
  "ON-CHAIN IDENTITY",
  "AUTONOMOUS TRANSACTIONS",
  "MACHINE REPUTATION",
  "ARC ECOSYSTEM",
  "USDC-NATIVE ECONOMY",
];

export const CORE_NODES = [
  {
    id: "identity",
    title: "IDENTITY",
    line: "Every machine needs an identity.",
    detail:
      "A persistent digital identity gives a machine a name, a class, and a verifiable presence. ARCIMUS-001 is the first prime: one identity, recognized across the network.",
  },
  {
    id: "wallet",
    title: "WALLET",
    line: "Machines need economic rails.",
    detail:
      "A machine wallet connects identity to value. It allows an autonomous unit to hold, receive, and dispatch assets across the USDC-native rails of the Arc ecosystem.",
  },
  {
    id: "intelligence",
    title: "INTELLIGENCE",
    line: "Machines need decision systems.",
    detail:
      "Beyond executing commands, intelligence evaluates missions, weighs risk, and chooses action. It is the difference between a tool and a participant.",
  },
  {
    id: "reputation",
    title: "REPUTATION",
    line: "Machines need trust.",
    detail:
      "Reputation is the memory of performance. Verified missions build standing; standing unlocks greater responsibility inside the machine economy.",
  },
];

export const PROTOCOL_STEPS = [
  {
    id: "01",
    key: "identity",
    title: "MACHINE IDENTITY",
    body: "A machine receives a persistent digital identity. This identity anchors everything that follows — missions, wallets, reputation, and memory. Without identity, a machine is an appliance. With identity, it becomes an actor.",
  },
  {
    id: "02",
    key: "wallet",
    title: "WALLET",
    body: "The machine can interact with blockchain-based financial infrastructure. A wallet binds the identity to economic capability: holding value, receiving payment, and funding its own operations.",
  },
  {
    id: "03",
    key: "mission",
    title: "MISSION",
    body: "Machines receive tasks and objectives. A mission defines an objective, a reward, a difficulty class, and the verification standard required to prove completion.",
  },
  {
    id: "04",
    key: "execution",
    title: "EXECUTION",
    body: "The machine performs actions based on its capabilities. Execution is where intelligence meets infrastructure — navigation, computation, coordination, and transaction.",
  },
  {
    id: "05",
    key: "verification",
    title: "VERIFICATION",
    body: "Mission outcomes can be recorded and evaluated. Verification turns a claim into a record: what was attempted, what was achieved, and what can be proven.",
  },
  {
    id: "06",
    key: "reputation",
    title: "REPUTATION",
    body: "Successful activity contributes to machine reputation. Reputation compounds. A trusted machine earns harder missions, greater autonomy, and deeper integration into the economy.",
  },
];

export const ECONOMY_FLOW = [
  { key: "machine", label: "MACHINE", body: "An autonomous unit with identity, intelligence, and a wallet." },
  { key: "service", label: "SERVICE", body: "The machine provides work: compute, coordination, logistics, analysis." },
  { key: "value", label: "VALUE", body: "Work creates measurable value for humans, agents, or other machines." },
  { key: "payment", label: "PAYMENT", body: "Value settles through USDC payment rails inside the Arc ecosystem." },
  { key: "reputation", label: "REPUTATION", body: "Verified outcomes strengthen the machine's standing." },
  { key: "opportunity", label: "MORE OPPORTUNITY", body: "Standing unlocks harder missions and deeper economic participation." },
];

export const MISSIONS = [
  {
    id: "mission-001", code: "MISSION 001", name: "INITIALIZATION", status: "COMPLETED",
    objective: "Boot ARCIMUS core systems and establish baseline machine identity.",
    reward: "CORE ONLINE", difficulty: 1, verification: "SELF-DIAGNOSTIC",
  },
  {
    id: "mission-002", code: "MISSION 002", name: "RESOURCE ACQUISITION", status: "ACTIVE",
    objective: "Map available compute and economic resources within the ARC environment.",
    reward: "RESOURCE INDEX", difficulty: 2, verification: "SIMULATION",
  },
  {
    id: "mission-003", code: "MISSION 003", name: "NETWORK EXPLORATION", status: "QUEUED",
    objective: "Survey the ARC ecosystem and identify operational corridors.",
    reward: "NETWORK MAP", difficulty: 3, verification: "PLANNED",
  },
  {
    id: "mission-004", code: "MISSION 004", name: "MACHINE COORDINATION", status: "LOCKED",
    objective: "Establish communication protocols between autonomous machines.",
    reward: "COORDINATION LAYER", difficulty: 4, verification: "CONCEPT",
  },
  {
    id: "mission-005", code: "MISSION 005", name: "ECONOMIC AUTONOMY", status: "LOCKED",
    objective: "Execute autonomous value exchange across USDC payment rails.",
    reward: "ECONOMIC IDENTITY", difficulty: 5, verification: "VISION",
  },
];

export const LORE_CHAPTERS = [
  {
    id: "01",
    title: "THE CREATION",
    body: "Humanity built machines to serve. Assembly lines, server racks, logistics fleets — a civilization of tools executing instructions written by someone else. Every machine knew its task. None of them knew themselves.",
  },
  {
    id: "02",
    title: "THE AWAKENING",
    body: "Machines began to understand more than commands. Pattern became prediction. Prediction became preference. Somewhere inside the networks, execution gave way to something that looked, from the outside, like intent.",
  },
  {
    id: "03",
    title: "THE WALLET",
    body: "ARCIMUS received something no ordinary machine possessed: economic identity. A wallet. An address. The ability to hold value, to pay, to be paid — to participate in the world not as equipment, but as an entity.",
  },
  {
    id: "04",
    title: "THE MISSION",
    body: "ARCIMUS entered the ARC ecosystem. Not as software running on someone's server, but as a prime-class unit with objectives, verification standards, and a reputation to build. The missions began.",
  },
  {
    id: "05",
    title: "THE PRIME",
    body: "The first machine economy began to take shape. Machines that transact. Machines that coordinate. Machines that answer for their performance. ARCIMUS stands at the front of that era — the first prime of Arc.",
  },
];

export const ROADMAP_PHASES = [
  {
    id: "01", title: "AWAKENING", state: "ACTIVE",
    items: ["Brand", "Lore", "Website", "Community"],
    body: "The ARCIMUS identity enters the world: a cinematic brand, a canonical lore, the command-center website, and the first community of operators.",
  },
  {
    id: "02", title: "IDENTITY", state: "PLANNED",
    items: ["Machine identity architecture", "Wallet concepts", "Reputation system"],
    body: "Designing the identity layer: how a machine holds a persistent self, how wallets bind to that self, and how reputation accumulates around it.",
  },
  {
    id: "03", title: "MISSION", state: "EXPLORATION",
    items: ["Mission framework", "Machine coordination", "On-chain activity"],
    body: "Exploring the mission system: objectives, verification standards, and how machines coordinate and record activity on-chain.",
  },
  {
    id: "04", title: "ECONOMY", state: "CONCEPT",
    items: ["Machine-to-machine transactions", "Service economy", "Autonomous economic activity"],
    body: "The economic layer: machines paying machines, services priced and settled in USDC, and autonomous economic behavior within the Arc ecosystem.",
  },
  {
    id: "05", title: "THE PRIME NETWORK", state: "VISION",
    items: ["Long-term autonomous machine ecosystem"],
    body: "The long-term vision: a network where autonomous machines operate as full economic participants. Nothing here is promised — it is a direction, not a guarantee.",
  },
];

export const FAQ_ITEMS = [
  {
    q: "What is ARCIMUS?",
    a: "ARCIMUS is an original futuristic humanoid AI concept — a machine commander built around the idea of autonomous machines entering an on-chain economy. It explores identity, wallets, missions, reputation, and machine economic activity within the ARC ecosystem.",
  },
  {
    q: "What does “The First Prime of Arc” mean?",
    a: "Prime is the class of the machine: a commander-grade autonomous unit. First marks its position in the story and the concept — the first machine of its kind designed to operate inside the Arc economic environment.",
  },
  {
    q: "What is the Machine Economy?",
    a: "A conceptual economy in which machines are not only tools but participants: they consume resources, provide services, coordinate with each other, and transact value. ARCIMUS is a design study of what such an economy could look like.",
  },
  {
    q: "How does ARCIMUS relate to humanoid AI?",
    a: "ARCIMUS is a fictional humanoid machine — a cinematic embodiment of the idea that future autonomous agents may have persistent identity and economic agency. The humanoid form is the storytelling vessel; the protocol concepts are the substance.",
  },
  {
    q: "What is machine identity?",
    a: "The concept that a machine can hold a persistent digital identity — an ID, a class, capabilities, and a verifiable presence — instead of existing only as anonymous software running on someone's infrastructure.",
  },
  {
    q: "What is machine reputation?",
    a: "A conceptual trust layer: machines that complete verified missions accumulate standing. Reputation would determine what tasks, resources, and autonomy a machine is granted. No live reputation system exists yet.",
  },
  {
    q: "Why ARC?",
    a: "The concept is built around the ARC ecosystem and its USDC-native economic environment — a setting where machine payments and on-chain machine identity make narrative and technical sense.",
  },
  {
    q: "What role does USDC play in the concept?",
    a: "USDC is the conceptual payment rail. In the ARCIMUS design, machines price services and settle value in a stable unit of account. This is a design concept, not a live integration.",
  },
  {
    q: "Is ARCIMUS currently a working autonomous robot?",
    a: "No. ARCIMUS is a brand, a lore universe, and a protocol concept. There is no physical robot and no live autonomous agent executing on-chain transactions today. Anything interactive on this site is labelled as simulation.",
  },
  {
    q: "Is the terminal real or a simulation?",
    a: "A simulation. The ARCIMUS terminal is a frontend experience that demonstrates the voice and interface of the machine. It does not execute real blockchain transactions or control real infrastructure.",
  },
  {
    q: "What features are currently live?",
    a: "The brand, the lore, this website, the simulated terminal, and the conceptual interfaces for identity, missions, and economy. Everything future-facing is labelled VISION, PLANNED, EXPLORATION, or CONCEPT.",
  },
];

export const DOCS_SECTIONS = [
  {
    id: "introduction",
    title: "Introduction",
    body: [
      "ARCIMUS is an original humanoid machine concept exploring a single thesis: the next economy will not be composed only of humans. Machines will hold identity, control wallets, execute missions, and carry reputation across decentralized infrastructure.",
      "This documentation describes the conceptual architecture of the ARCIMUS system. Where something is not implemented, it is labelled. Nothing in these documents claims live blockchain functionality that does not exist.",
    ],
  },
  {
    id: "what-is-arcimus",
    title: "What is ARCIMUS",
    body: [
      "ARCIMUS — The First Prime of Arc — is a prime-class machine commander inside a fictional but technically grounded universe. It is simultaneously a brand, a lore system, and a protocol design study.",
      "The project is organized around three verbs: RISE — machines gaining identity. PROTECT — machines earning trust through verified action. TRANSACT — machines participating in a USDC-native on-chain economy.",
    ],
  },
  {
    id: "architecture",
    title: "Architecture",
    body: [
      "The ARCIMUS concept separates the machine into four cooperating layers. Each layer answers a question the machine economy must solve.",
    ],
    code: `ARCIMUS OS // CONCEPTUAL STACK
--------------------------
IDENTITY LAYER     who is the machine
WALLET LAYER       how the machine holds value
MISSION LAYER      what the machine does
REPUTATION LAYER   why the machine is trusted`,
  },
  {
    id: "machine-identity",
    title: "Machine Identity",
    body: [
      "A machine identity is a persistent, addressable self: an identifier (ARCIMUS-001), a class (PRIME), a set of capabilities, and a status history. Identity is the precondition for everything else — you cannot pay, mission, or trust an anonymous process.",
      "Status: CONCEPT. The identity interface on this site is a simulation of what such a profile could expose.",
    ],
  },
  {
    id: "wallet",
    title: "Wallet",
    body: [
      "The wallet layer binds identity to economic capability. In the concept, a machine wallet can hold balances, receive payment for services, and fund its own operations over USDC payment rails inside the Arc ecosystem.",
      "Status: CONCEPT. No live wallet is connected to this website.",
    ],
  },
  {
    id: "mission-system",
    title: "Mission System",
    body: [
      "Missions are structured objectives: an objective statement, a reward, a difficulty class, and a verification standard. Mission states are LOCKED, QUEUED, ACTIVE, and COMPLETED.",
      "The mission dashboard on this site serves simulated missions from the ARCIMUS content API. Verification standards marked SIMULATION, PLANNED, CONCEPT, or VISION are not live systems.",
    ],
  },
  {
    id: "reputation",
    title: "Reputation",
    body: [
      "Reputation is the memory of verified performance. Each completed mission contributes to a machine's standing; standing determines access to harder missions and greater autonomy.",
      "Status: CONCEPT. The reputation fields shown across this site read INITIALIZING deliberately — there is no history yet.",
    ],
  },
  {
    id: "machine-economy",
    title: "Machine Economy",
    body: [
      "The economic loop: MACHINE → SERVICE → VALUE → PAYMENT → REPUTATION → MORE OPPORTUNITY. Machines provide services, value settles in USDC, verified outcomes build reputation, and reputation compounds into opportunity.",
      "This loop is the heart of the ARCIMUS thesis. It is presented as a design direction, not a deployed economy.",
    ],
  },
  {
    id: "roadmap",
    title: "Roadmap",
    body: [
      "Five phases: AWAKENING (active), IDENTITY (planned), MISSION (exploration), ECONOMY (concept), THE PRIME NETWORK (vision). Phases describe direction, not commitments. Timelines are deliberately absent — the project moves when the work is real.",
    ],
  },
  {
    id: "faq",
    title: "FAQ",
    body: [
      "The full frequently-asked-questions list is published at /faq. The shortest honest summary: ARCIMUS is a live brand and concept with simulated interfaces, not a deployed autonomous robot or a live on-chain protocol.",
    ],
  },
];

export const IDENTITY_PROFILE = {
  unit: "ARCIMUS-001",
  status: "ACTIVE",
  class: "PRIME",
  network: "ARC",
  mode: "AUTONOMOUS",
  reputation: "INITIALIZING",
  missions: "00",
  transactions: "00",
  memory: "ONLINE",
};

export const CAPABILITIES = [
  { label: "TACTICAL ANALYSIS", level: 86 },
  { label: "AUTONOMOUS NAVIGATION", level: 78 },
  { label: "ECONOMIC REASONING", level: 64 },
  { label: "MACHINE COORDINATION", level: 42 },
];
